(ns practitest.frontend.components2.dashboard.charts.readiness-gauge
  (:require [practitest.frontend.components2.dashboard.charts.protocol :as p]
            [practitest.frontend.components2.dashboard.chart :as-alias chart]
            [practitest.frontend.components2.dashboard.charts.render :as r]
            [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components2.dashboard.charts.gauge :as gauge]))

(defn base-spec [{:keys [rrqi not-available? icon]}]
  (-> (gauge/base-spec {:value          rrqi
                        :display-value  rrqi
                        :not-available? not-available?
                        :icon           icon
                        :label          (get-translation "readiness-gauge.label" "Readiness Score")})
      (assoc :mark {:type :gauge :tick-count 10})))

(defmethod p/render! ::chart/readiness-gauge [chart _ctx svg-el]
  (r/render-chart! svg-el (base-spec chart)))
